import "./SendNews.module.css";
import Header from "@/reusable_sections/Header";
import Mediauploadsection from "./sections/Mediauploadsection";
import InformasiKejadianForm from "./sections/InformasiKejadianForm";
import Submissionconfirmation from "./sections/Submissionconfirmation";
import Sidebarhelpcard from "./sections/Sidebarhelpcard";
import InformasiKontak from "@/reusable_sections/Footer";
import Informationdeliveryguidelines from "./sections/Informationdeliveryguidelines";
import Statuskelengkapanlaporan from "./sections/Statuskelengkapanlaporan";
import Statusverifikasiredaksi from "./sections/Statusverifikasiredaksi";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
export default function SendNewsPage() {
  return <div className="min-h-screen bg-gray-50">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 py-10 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {}
          <div className="lg:col-span-2 space-y-12">
            {}
            <Informationdeliveryguidelines />

            {}
            <Mediauploadsection />

            {}
            <InformasiKejadianForm />

            {}
            <Statuskelengkapanlaporan />

            {}
            <Statusverifikasiredaksi />

            {}
            <Submissionconfirmation />
          </div>

          {}
          <aside className="lg:col-span-1">
            <div className="sticky top-8">
              <Sidebarhelpcard />
            </div>
          </aside>
        </div>
      </main>

      <GlossyBottomNavigation />
      <InformasiKontak />
    </div>;
}